import moment from 'moment-timezone';

const clockFormats = {
  'de-DE': 'Do MMMM HH:mm z',
  'en-GB': 'D MMMM HH:mm z',
  'fr-FR': 'Do MMMM HH:mm z',
  'en-US': 'MMMM D h:mma z',
  'it-IT': 'D MMMM HH:mm z',
  'es-ES': 'D [de] MMMM HH:mm z',
  'pt-BR': 'D [de] MMMM HH:mm z'
};

export function formatForClock(datetime = Date.now(), timezone, {format, locale}) {
  return moment.tz(datetime, timezone).format(format || clockFormats[locale]);
}
